export default "__VITE_ASSET__BnpUqEa6__"